import { dataAfterSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAfterSquareSolid = /*#__PURE__*/createIcon(dataAfterSquareSolid)
export default IconAfterSquareSolid
